import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CommonBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import ScoringLoading from "src/components/utils/ScoringLoading";
import { useTokenAnalysisContext, useTokenAnalysisSelector } from "src/context/tokenAnalysisContext";
import ActivityInfo from "./ActivityInfo";
import Analysis from "./Analysis";
import HealthOverview from "./HealthOverview";
import SubTokenTitle from "./SubTokenTitle";
import TokenDetailChart from "./TokenDetailChart";

export default function TokenHealthDetail() {
  const { tokenId } = useParams();
  const { getDescriptionToken } = useTokenAnalysisContext();
  const tokens = useTokenAnalysisSelector((state) => state.tokens);
  const { getTokenHistory } = useTokenAnalysisContext();

  const [tokenDetailData, setTokenDetailData] = useState(null);
  const [tokenDescription, setTokenDescription] = useState(null);
  const [historyData, setHistoryData] = useState(null);

  useEffect(async () => {
    const _tempData = await getDescriptionToken(tokenId);
    setTokenDescription(_tempData);
  }, [tokenId, getDescriptionToken]);

  useEffect(() => {
    if (tokens) {
      const _token = tokens?.find((element) => element["token_id"] === tokenId);
      if (_token) setTokenDetailData(_token);
    }
  }, [tokenId, tokens]);

  useEffect(async () => {
    const _tempData = await getTokenHistory(tokenId);
    setHistoryData(_tempData);
  }, [tokenId, getTokenHistory]);

  return (
    <>
      {tokenDetailData ? (
        <>
          <CommonBreadcrumb
            config={[
              { text: "scoring" },
              { text: "tokens health", link: "/tokens-health" },
              {
                text: tokenDetailData?.symbol,
                link: `/tokens-health/${tokenId}`,
                formatter: (text) => text.toUpperCase(),
              },
            ]}
          />
          <SubTokenTitle
            tokenId={tokenId}
            tokenName={tokenDetailData.name}
            tokenCategories={tokenDetailData.categories}
            mt={3}
          />
          <ActivityInfo token={tokenDetailData} mt={3} />
          <HealthOverview historyData={historyData} token={tokenDetailData} mt={5} />
          <Analysis analysis={tokenDescription?.analysis} suggestions={tokenDescription?.suggestions} />
          <TokenDetailChart historyData={historyData} mt={5} />
        </>
      ) : (
        <ScoringLoading style={{ alignItems: "flex-start" }} />
      )}
    </>
  );
}
